const FILTRO_EMPTY = (caixa, numeroOs = '') => {
  return {
    simples: true,
    avancada: false,
    lote: false,
    caixa: caixa,
    campoSimples: '',
    numeroProcesso: '',
    cpfCnpjInteressado: '',
    nomeInteressado: '',
    tipos: [],
    credenciado: '',
    setorOrigem: '',
    statusSolicitacao: '',
    tipo: '',
    nomePlanilha: '',
    responsavel: '',
    status: '',
    situacaoClausulaResolutiva: '',
    numeroOs: numeroOs,
    funcao: '',
    dataVencimento: null,
    numeroTitulo: '',
    municipio: [],
    bairros: [],
    situacaoCertidao: '',
    situacao: null,
    receita: '',
    ordem: '',
    pagina: 0,
    tipoPagamentoVtn: null,
    dataArquivamento: null,
    periodoPublicacao: null,
    numeroPublicacaoPortaria: null,
    area: null,
    denominacao: null,
    numeroPortaria: null,
    numeroRecibo: '',
    simplificado: true,
    nomeCadastrante: '',
    colunas: []
  }
}

export default FILTRO_EMPTY



// WEBPACK FOOTER //
// ./src/models/filtro.js